import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
/**
 * Sticky bottom bar shown on ALL viewports (mobile + desktop).
 * Appears after the user scrolls past the hero.
 * Hides once the user reaches the final CTA section or the footer
 * (to avoid double-CTA noise at the bottom of the page).
 */
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const HERO_THRESHOLD = 600;
    const handleScroll = () => {
      const scrolledPastHero = window.scrollY > HERO_THRESHOLD;
      // Hide once final CTA section enters the viewport
      const finalCTA = document.getElementById('final-cta-section');
      let beforeFinalCTA = true;
      if (finalCTA) {
        const rect = finalCTA.getBoundingClientRect();
        // Hide as soon as the final CTA top crosses below ~85% of viewport
        if (rect.top < window.innerHeight * 0.85) {
          beforeFinalCTA = false;
        }
      }
      setIsVisible(scrolledPastHero && beforeFinalCTA);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToPricing = () => {
    document.getElementById('pricing-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-306">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 24
    }} className="fixed bottom-0 left-0 right-0 z-40 bg-cream border-t-2 border-clay/40 shadow-[0_-12px_30px_-10px_rgba(43,37,32,0.15)]" data-id="element-307">
          <div className="max-w-6xl mx-auto px-4 py-3 flex items-center justify-between gap-3" data-id="element-308">
            <div className="flex flex-col leading-tight min-w-0" data-id="element-309">
              <span className="font-serif text-base md:text-lg text-ink font-bold truncate" data-id="element-310">
                Apaga Tu Inflamación
              </span>
              <span className="text-xs md:text-sm text-muted" data-id="element-311">
                <span className="font-bold text-clay text-base md:text-lg" data-id="element-312">
                  $9.99 USD
                </span>
                <span className="ml-2 text-sage font-bold text-[11px] md:text-xs uppercase tracking-wider" data-id="element-313">
                  75% OFF
                </span>
              </span>
            </div>
            <a href="https://www.epikkastore.com/cart/45160332132375:1" className="shrink-0 bg-clay hover:bg-clay-dark text-ivory font-semibold text-sm md:text-base py-3 px-5 md:px-7 rounded-full transition-all shadow-md hover:shadow-lg hover:-translate-y-0.5 duration-200 flex items-center gap-2" data-id="element-314">
              <span data-id="element-315">Quiero mi guía</span>
              <ArrowRight className="w-4 h-4" data-id="element-316" />
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}